import { createSelector } from 'reselect';
import { isFeatureEnabled } from '../../../common/users/utils/userPropertyUtils';
import { getCurrentUser } from '../../user/currentUserSelector';
import { ExperimentId } from '../../../common/experiments/experimentsConstants';

/**
 * @param {string} feature Feature Flag ID
 * @param {boolean} defaultValue Default value if the isFeatureEnabled is undefined (e.g. guest)
 */
export const getIsFeatureEnabledForCurrentUser = (feature: ExperimentId, defaultValue = false) =>
    createSelector(getCurrentUser, (currentUser) => {
        const isFeatureEnabledForCurrentUser = isFeatureEnabled(feature, currentUser);

        return isFeatureEnabledForCurrentUser ?? defaultValue;
    });
